import { globals } from '@/src/globals'
import axios from 'axios/dist/axios'

export const axios_mailChimpSubscribe = () => {
  const mailChimpInput = document.querySelector('.js-mailChimpSubsribe-input') as unknown as HTMLInputElement
  const mailChimpSubmit = document.querySelector('.js-mailChimpSubsribe-submit') as unknown as HTMLElement

  const mailShowElements = document.querySelectorAll('.js-mailChimpSubsribe-show') as unknown as HTMLElement[]
  const mailHideElements = document.querySelectorAll('.js-mailChimpSubsribe-hide') as unknown as HTMLElement[]

  let hasProperMail = false

  // Validate email function
  const validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  const checkEmail = () => {
    const emailInput = mailChimpInput.value

    if (validateEmail(emailInput)) {
      hasProperMail = true
    } else {
      hasProperMail = false
    }

    checkValues()
  }

  // Enable or disable button
  const checkValues = () => {
    if (hasProperMail) {
      mailChimpSubmit.classList.remove('-disabled')
    } else {
      mailChimpSubmit.classList.add('-disabled')
    }
  }

  // Check once on script load to be sure
  checkEmail()

  // Listen to changes on input box
  mailChimpInput.addEventListener('keyup', () => {
    checkEmail()
  })

  // Listen to clicks on the submit button
  mailChimpSubmit.addEventListener('click', () => {
    if (!mailChimpSubmit.classList.contains('-disabled')) {
      const emailInput = mailChimpInput.value
      subscribeEmail(emailInput)
    }
  })

  const subscribeEmail = (email) => {
    const requestURL = `${globals.externalInput.wpAjaxCallURL}?action=callMailchimpAPI&email=${email}`

    axios.get(requestURL)
      .then(response => {
        mailShowElements.forEach(element => {
          element.classList.remove('hidden')
        })
        mailHideElements.forEach(element => {
          element.classList.add('hidden')
        })
      })
      .catch(e => {
        console.log(e)
      })
  }
}
